export const LOADING_DDI = "LOADING_DDI";
export const SET_LIST_PAIS = "SET_LIST_PAIS";
export const SET_DDI_FIXO_BRASIL = "SET_DDI_FIXO_BRASIL";
